export const state = () => ({
  socialMediaList: [],
  createSocialMediaSuccess: null,
  deleteSocialMediaSuccess: null,
  updateSocialMediaSuccess: null,
});
